/**
 * RESPONSIBILITY: the Events page's opening band.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only.
 */
import { Section, Text, Paragraph } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { ABOVE_HINT } from '../hints';

@Section({ name: SectionName.EventsHero, label: 'Events - Page head' })
export class EventsHeroSection {
  @Text({ label: 'Subtitle', maxLength: 120, default: "What's on", description: ABOVE_HINT })
  eyebrow!: string;
  @Text({ label: 'Title', maxLength: 300, default: 'Events' })  heading!: string;
  @Paragraph({ label: 'Description', maxLength: 4000, rows: 2 }) intro!: string;
}
